export default __webpack_public_path__ + "static/media/ignite.4dc8fba4.png";